import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import ActionButtonListComponent from './ActionButtonListComponent.jsx';
import CustomProtocolOpenerComponent
  from './CustomProtocolOpenerComponent.jsx';
import { metrics as metricsHelpers } from '../helpers';

const getMetricsOfInterest = (metrics) => {
  const checkEquals = [metricsHelpers.NCF_UNHANDLEDARTIFACTCOUNT];
  const checkEndsWith = [
    // error and output code are here so that past information will still be displayed
    metricsHelpers.RUN_CASE_METRICS_DIFF_ERROR_CODE_SUFFIX,
    metricsHelpers.RUN_CASE_METRICS_DIFF_OUTPUT_CODE_SUFFIX,
    metricsHelpers.RUN_CASE_METRICS_DIFF_RESULT_SUFFIX,
    metricsHelpers.RUN_CASE_METRICS_DIFF_RETURN_CODE_SUFFIX,
    metricsHelpers.RUN_CASE_METRICS_DIFF_STATUS_CODE_SUFFIX,
  ];
  const result = Object.keys(metrics)
    .filter(m =>
      m &&
      checkEquals.some(expected => m === expected) ||
      checkEndsWith.some(expected => m.endsWith(expected))
    );
  return result;
};

const MetricsJobInfoComponent = ({
  displayParams,
  job,
  metrics,
  metricsActions,
  onActionButtonClick,
  paramsActions,
  title
}) => {
  const relevantMetricKeys = getMetricsOfInterest(metrics);
  return (
    <div>
      <Panel collapsible="true" defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>
            {title ? 'Params:' + title : 'Params None Selected'}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            { displayParams ?
              <div>
                <Row>
                  <Col md={5}> JobDate: </Col>
                  <Col md={5}> {job ? job.created_at : ''} </Col>
                  <Col md={2}>
                    <ActionButtonListComponent
                      actions={paramsActions}
                      itemId = {job ? job.id : 0}
                      onButtonClick={onActionButtonClick}
                    />
                  </Col>
                </Row>
                { Object.keys(displayParams)
                  .sort()
                  .map((key, i) => (
                    <Row key={i}>
                      <Col md={5}> {key} </Col>
                      <Col md={5}> {displayParams[key]} </Col>
                    </Row>
                  ))
                }
              </div> :
              null
            }
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
      {relevantMetricKeys.length > 0 ?
        (<div>
          <Panel collapsible="true" defaultExpanded>
            <Panel.Heading>
              <Panel.Title toggle>
                {title ? 'Metrics:' + title : 'Metrics None Selected'}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Collapse>
              <Panel.Body>
                <div>
                  <Row>
                    <Col md={5} />
                    <Col md={5} />
                    <Col md={2}>
                      <ActionButtonListComponent
                        actions={metricsActions}
                        itemId = {job ? job.id : 0}
                        onButtonClick={onActionButtonClick}
                      />
                    </Col>
                  </Row>
                  { relevantMetricKeys
                    .sort()
                    .map((key, i) => {
                      const metric = metrics[key];
                      if (!metric) { return null; }
                      return (
                        <Row key={i}>
                          <Col md={5}> {key} </Col>
                          <Col md={5}> {metrics[key]} </Col>
                        </Row>
                      );
                    }).filter(x => x)
                  }
                </div>
              </Panel.Body>
            </Panel.Collapse>
          </Panel>
          <Row>
            <CustomProtocolOpenerComponent />
          </Row>
        </div>) :
        null
      }
    </div>
  );
};

MetricsJobInfoComponent.propTypes = {
  displayParams: PropTypes.object,
  hasCcfDiff: PropTypes.bool.isRequired,
  hasNcfDiff: PropTypes.bool.isRequired,
  job: PropTypes.object,
  metrics: PropTypes.object.isRequired,
  metricsActions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  paramsActions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  title: PropTypes.string,
};

export default MetricsJobInfoComponent;


// WEBPACK FOOTER //
// src/Components/MetricsJobInfoComponent.jsx